import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { GroupVideoCallHeader } from '@gem/call/CallView/CompactCallView/GroupVideoCall/GroupVideoCallHeader/GroupVideoCallHeader';
import { MembersPanel } from '@gem/call/CallView/CompactCallView/GroupVideoCall/MembersPanel/MembersPanel';
import { CompactScreenVideoLayout } from '@gem/call/CallView/CompactCallView/Shared/CompactScreenVideoLayout/CompactScreenVideoLayout';
import { SpeakerVideo } from '@gem/call/CallView/CompactCallView/Shared/SpeakerVideo/SeakerVideo';
import { AnimatedBackgroundPanel } from '@gem/call/CallView/Shared/AnimatedBackgroundPanel/AnimatedBackgroundPanel';
import { CallActionsPanel } from '@gem/call/CallView/Shared/CallActionsPanel/CallActionsPanel';
import { EventsBar } from '@gem/call/CallView/Shared/EventsBar/EventsBar';
import { WaitingAudioOpponentsToast } from '@gem/call/CallView/Shared/WaitingAudioOpponentsToast/WaitingAudioOpponentsToast';

import { useMobileCompactCallViewPresenter } from './MobileCompactCallView.presenter';
import styles from './MobileCompactCallView.styles.m.css';

export const MobileCompactCallView: FC = observer(() => {
  const { call } = useMobileCompactCallViewPresenter();
  return (
    <div className={styles.container}>
      <div className={styles.compactCallViewContainer}>
        {!call.viewState.isMembersShown && (
          <div className={styles.groupVideoCallView}>
            <GroupVideoCallHeader />
            {call.viewState.isGridLayout ? <CompactScreenVideoLayout /> : <SpeakerVideo />}
            <CallActionsPanel />
          </div>
        )}
        {call.viewState.isMembersShown && (
          <div className={styles.membersPanelContainer}>
            <MembersPanel call={call} />
          </div>
        )}
        <EventsBar />
        <AnimatedBackgroundPanel isCompact />
      </div>
      <WaitingAudioOpponentsToast />
    </div>
  );
});
